export default {
	blockPackingMethod: require('./block-packing-method').default,
	imageProcessingLibrary: require('./image-processing-library').default,
	reporter: require('./reporter').default
};